import mutations from './role.mutations'
import actions from './role.actions'
import getters from './role.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
